/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getInitConfigCodec,
  getLaunchCodec,
  getLaunchFeeStateCodec,
  getPoolCodec,
  getPositionCodec,
  getVestingConfigCodec,
  type InitConfig,
  type InitConfigArgs,
  type Launch,
  type LaunchArgs,
  type LaunchFeeState,
  type LaunchFeeStateArgs,
  type Pool,
  type PoolArgs,
  type Position,
  type PositionArgs,
  type VestingConfig,
  type VestingConfigArgs,
} from '../accounts';
import {
  getClaimFeesInstructionAsync,
  getCurveSwapExactInInstructionAsync,
  getDistributeBaseAllocationNoMigrationInstructionAsync,
  getFundVestingInstructionAsync,
  getHarvestMigratedFeesInstructionAsync,
  getInitializeConfigInstructionAsync,
  getInitializeLaunchInstructionAsync,
  getMigrateLaunchInstructionAsync,
  getMigratorInitInstructionAsync,
  getPreviewMigrationInstructionAsync,
  getPreviewSwapExactInInstructionAsync,
  getReplaceFeeBeneficiaryInstructionAsync,
  getSetFeePolicyInstructionAsync,
  getSetHookAllowlistInstructionAsync,
  getSetMigratorAllowlistInstructionAsync,
  getTransferAdminInstructionAsync,
  getUpdateTradingFlagsInstructionAsync,
  parseClaimFeesInstruction,
  parseCurveSwapExactInInstruction,
  parseDistributeBaseAllocationNoMigrationInstruction,
  parseFundVestingInstruction,
  parseHarvestMigratedFeesInstruction,
  parseInitializeConfigInstruction,
  parseInitializeLaunchInstruction,
  parseMigrateLaunchInstruction,
  parseMigratorInitInstruction,
  parsePreviewMigrationInstruction,
  parsePreviewSwapExactInInstruction,
  parseReplaceFeeBeneficiaryInstruction,
  parseSetFeePolicyInstruction,
  parseSetHookAllowlistInstruction,
  parseSetMigratorAllowlistInstruction,
  parseTransferAdminInstruction,
  parseUpdateTradingFlagsInstruction,
  type ClaimFeesAsyncInput,
  type CurveSwapExactInAsyncInput,
  type DistributeBaseAllocationNoMigrationAsyncInput,
  type FundVestingAsyncInput,
  type HarvestMigratedFeesAsyncInput,
  type InitializeConfigAsyncInput,
  type InitializeLaunchAsyncInput,
  type MigrateLaunchAsyncInput,
  type MigratorInitAsyncInput,
  type ParsedClaimFeesInstruction,
  type ParsedCurveSwapExactInInstruction,
  type ParsedDistributeBaseAllocationNoMigrationInstruction,
  type ParsedFundVestingInstruction,
  type ParsedHarvestMigratedFeesInstruction,
  type ParsedInitializeConfigInstruction,
  type ParsedInitializeLaunchInstruction,
  type ParsedMigrateLaunchInstruction,
  type ParsedMigratorInitInstruction,
  type ParsedPreviewMigrationInstruction,
  type ParsedPreviewSwapExactInInstruction,
  type ParsedReplaceFeeBeneficiaryInstruction,
  type ParsedSetFeePolicyInstruction,
  type ParsedSetHookAllowlistInstruction,
  type ParsedSetMigratorAllowlistInstruction,
  type ParsedTransferAdminInstruction,
  type ParsedUpdateTradingFlagsInstruction,
  type PreviewMigrationAsyncInput,
  type PreviewSwapExactInAsyncInput,
  type ReplaceFeeBeneficiaryAsyncInput,
  type SetFeePolicyAsyncInput,
  type SetHookAllowlistAsyncInput,
  type SetMigratorAllowlistAsyncInput,
  type TransferAdminAsyncInput,
  type UpdateTradingFlagsAsyncInput,
} from '../instructions';

export const INITIALIZER_PROGRAM_ADDRESS =
  '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1' as Address<'4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1'>;

export enum InitializerAccount {
  InitConfig,
  Launch,
  LaunchFeeState,
  Pool,
  Position,
  VestingConfig,
}

export function identifyInitializerAccount(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): InitializerAccount {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([97, 166, 35, 7, 20, 2, 164, 126]),
      ),
      0,
    )
  ) {
    return InitializerAccount.InitConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([144, 51, 51, 163, 206, 85, 213, 38]),
      ),
      0,
    )
  ) {
    return InitializerAccount.Launch;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([1, 106, 55, 241, 179, 18, 230, 232]),
      ),
      0,
    )
  ) {
    return InitializerAccount.LaunchFeeState;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([241, 154, 109, 4, 17, 177, 109, 188]),
      ),
      0,
    )
  ) {
    return InitializerAccount.Pool;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([170, 188, 143, 228, 122, 64, 247, 208]),
      ),
      0,
    )
  ) {
    return InitializerAccount.Position;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([0, 138, 71, 135, 26, 29, 43, 125]),
      ),
      0,
    )
  ) {
    return InitializerAccount.VestingConfig;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'initializer' },
  );
}

export enum InitializerInstruction {
  ClaimFees,
  CurveSwapExactIn,
  DistributeBaseAllocationNoMigration,
  FundVesting,
  HarvestMigratedFees,
  InitializeConfig,
  InitializeLaunch,
  MigrateLaunch,
  MigratorInit,
  PreviewMigration,
  PreviewSwapExactIn,
  ReplaceFeeBeneficiary,
  SetFeePolicy,
  SetHookAllowlist,
  SetMigratorAllowlist,
  TransferAdmin,
  UpdateTradingFlags,
}

export function identifyInitializerInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): InitializerInstruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([82, 251, 233, 156, 12, 52, 184, 202]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.ClaimFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([196, 247, 195, 126, 227, 27, 166, 93]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.CurveSwapExactIn;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([107, 200, 114, 3, 143, 2, 169, 56]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.DistributeBaseAllocationNoMigration;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([57, 58, 127, 28, 175, 154, 17, 125]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.FundVesting;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([63, 77, 73, 117, 2, 43, 255, 176]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.HarvestMigratedFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([208, 127, 21, 1, 194, 190, 196, 70]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.InitializeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([90, 201, 220, 142, 112, 253, 100, 13]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.InitializeLaunch;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([19, 199, 119, 103, 13, 30, 12, 205]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.MigrateLaunch;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([184, 104, 5, 97, 50, 28, 253, 16]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.MigratorInit;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([216, 180, 209, 112, 62, 16, 15, 63]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.PreviewMigration;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([50, 130, 31, 69, 147, 58, 222, 178]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.PreviewSwapExactIn;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([125, 194, 227, 81, 175, 100, 78, 200]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.ReplaceFeeBeneficiary;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([91, 32, 224, 109, 147, 98, 71, 132]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.SetFeePolicy;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([232, 28, 40, 143, 121, 182, 77, 103]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.SetHookAllowlist;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([209, 90, 181, 104, 99, 108, 233, 168]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.SetMigratorAllowlist;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([42, 242, 66, 106, 228, 10, 111, 156]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.TransferAdmin;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([40, 204, 40, 16, 219, 190, 133, 78]),
      ),
      0,
    )
  ) {
    return InitializerInstruction.UpdateTradingFlags;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'initializer' },
  );
}

export type ParsedInitializerInstruction<
  TProgram extends string = '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1',
> =
  | ({
      instructionType: InitializerInstruction.ClaimFees;
    } & ParsedClaimFeesInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.CurveSwapExactIn;
    } & ParsedCurveSwapExactInInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.DistributeBaseAllocationNoMigration;
    } & ParsedDistributeBaseAllocationNoMigrationInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.FundVesting;
    } & ParsedFundVestingInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.HarvestMigratedFees;
    } & ParsedHarvestMigratedFeesInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.InitializeConfig;
    } & ParsedInitializeConfigInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.InitializeLaunch;
    } & ParsedInitializeLaunchInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.MigrateLaunch;
    } & ParsedMigrateLaunchInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.MigratorInit;
    } & ParsedMigratorInitInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.PreviewMigration;
    } & ParsedPreviewMigrationInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.PreviewSwapExactIn;
    } & ParsedPreviewSwapExactInInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.ReplaceFeeBeneficiary;
    } & ParsedReplaceFeeBeneficiaryInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.SetFeePolicy;
    } & ParsedSetFeePolicyInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.SetHookAllowlist;
    } & ParsedSetHookAllowlistInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.SetMigratorAllowlist;
    } & ParsedSetMigratorAllowlistInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.TransferAdmin;
    } & ParsedTransferAdminInstruction<TProgram>)
  | ({
      instructionType: InitializerInstruction.UpdateTradingFlags;
    } & ParsedUpdateTradingFlagsInstruction<TProgram>);

export function parseInitializerInstruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedInitializerInstruction<TProgram> {
  const instructionType = identifyInitializerInstruction(instruction);
  switch (instructionType) {
    case InitializerInstruction.ClaimFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.ClaimFees,
        ...parseClaimFeesInstruction(instruction),
      };
    }
    case InitializerInstruction.CurveSwapExactIn: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.CurveSwapExactIn,
        ...parseCurveSwapExactInInstruction(instruction),
      };
    }
    case InitializerInstruction.DistributeBaseAllocationNoMigration: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType:
          InitializerInstruction.DistributeBaseAllocationNoMigration,
        ...parseDistributeBaseAllocationNoMigrationInstruction(instruction),
      };
    }
    case InitializerInstruction.FundVesting: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.FundVesting,
        ...parseFundVestingInstruction(instruction),
      };
    }
    case InitializerInstruction.HarvestMigratedFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.HarvestMigratedFees,
        ...parseHarvestMigratedFeesInstruction(instruction),
      };
    }
    case InitializerInstruction.InitializeConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.InitializeConfig,
        ...parseInitializeConfigInstruction(instruction),
      };
    }
    case InitializerInstruction.InitializeLaunch: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.InitializeLaunch,
        ...parseInitializeLaunchInstruction(instruction),
      };
    }
    case InitializerInstruction.MigrateLaunch: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.MigrateLaunch,
        ...parseMigrateLaunchInstruction(instruction),
      };
    }
    case InitializerInstruction.MigratorInit: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.MigratorInit,
        ...parseMigratorInitInstruction(instruction),
      };
    }
    case InitializerInstruction.PreviewMigration: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.PreviewMigration,
        ...parsePreviewMigrationInstruction(instruction),
      };
    }
    case InitializerInstruction.PreviewSwapExactIn: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.PreviewSwapExactIn,
        ...parsePreviewSwapExactInInstruction(instruction),
      };
    }
    case InitializerInstruction.ReplaceFeeBeneficiary: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.ReplaceFeeBeneficiary,
        ...parseReplaceFeeBeneficiaryInstruction(instruction),
      };
    }
    case InitializerInstruction.SetFeePolicy: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.SetFeePolicy,
        ...parseSetFeePolicyInstruction(instruction),
      };
    }
    case InitializerInstruction.SetHookAllowlist: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.SetHookAllowlist,
        ...parseSetHookAllowlistInstruction(instruction),
      };
    }
    case InitializerInstruction.SetMigratorAllowlist: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.SetMigratorAllowlist,
        ...parseSetMigratorAllowlistInstruction(instruction),
      };
    }
    case InitializerInstruction.TransferAdmin: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.TransferAdmin,
        ...parseTransferAdminInstruction(instruction),
      };
    }
    case InitializerInstruction.UpdateTradingFlags: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: InitializerInstruction.UpdateTradingFlags,
        ...parseUpdateTradingFlagsInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        {
          instructionType: instructionType as string,
          programName: 'initializer',
        },
      );
  }
}

export type InitializerPlugin = {
  accounts: InitializerPluginAccounts;
  instructions: InitializerPluginInstructions;
};

export type InitializerPluginAccounts = {
  initConfig: ReturnType<typeof getInitConfigCodec> &
    SelfFetchFunctions<InitConfigArgs, InitConfig>;
  launch: ReturnType<typeof getLaunchCodec> &
    SelfFetchFunctions<LaunchArgs, Launch>;
  launchFeeState: ReturnType<typeof getLaunchFeeStateCodec> &
    SelfFetchFunctions<LaunchFeeStateArgs, LaunchFeeState>;
  pool: ReturnType<typeof getPoolCodec> & SelfFetchFunctions<PoolArgs, Pool>;
  position: ReturnType<typeof getPositionCodec> &
    SelfFetchFunctions<PositionArgs, Position>;
  vestingConfig: ReturnType<typeof getVestingConfigCodec> &
    SelfFetchFunctions<VestingConfigArgs, VestingConfig>;
};

export type InitializerPluginInstructions = {
  claimFees: (
    input: ClaimFeesAsyncInput,
  ) => ReturnType<typeof getClaimFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  curveSwapExactIn: (
    input: CurveSwapExactInAsyncInput,
  ) => ReturnType<typeof getCurveSwapExactInInstructionAsync> &
    SelfPlanAndSendFunctions;
  distributeBaseAllocationNoMigration: (
    input: DistributeBaseAllocationNoMigrationAsyncInput,
  ) => ReturnType<
    typeof getDistributeBaseAllocationNoMigrationInstructionAsync
  > &
    SelfPlanAndSendFunctions;
  fundVesting: (
    input: MakeOptional<FundVestingAsyncInput, 'payer'>,
  ) => ReturnType<typeof getFundVestingInstructionAsync> &
    SelfPlanAndSendFunctions;
  harvestMigratedFees: (
    input: HarvestMigratedFeesAsyncInput,
  ) => ReturnType<typeof getHarvestMigratedFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeConfig: (
    input: InitializeConfigAsyncInput,
  ) => ReturnType<typeof getInitializeConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeLaunch: (
    input: MakeOptional<InitializeLaunchAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeLaunchInstructionAsync> &
    SelfPlanAndSendFunctions;
  migrateLaunch: (
    input: MakeOptional<MigrateLaunchAsyncInput, 'payer'>,
  ) => ReturnType<typeof getMigrateLaunchInstructionAsync> &
    SelfPlanAndSendFunctions;
  migratorInit: (
    input: MakeOptional<MigratorInitAsyncInput, 'payer'>,
  ) => ReturnType<typeof getMigratorInitInstructionAsync> &
    SelfPlanAndSendFunctions;
  previewMigration: (
    input: PreviewMigrationAsyncInput,
  ) => ReturnType<typeof getPreviewMigrationInstructionAsync> &
    SelfPlanAndSendFunctions;
  previewSwapExactIn: (
    input: PreviewSwapExactInAsyncInput,
  ) => ReturnType<typeof getPreviewSwapExactInInstructionAsync> &
    SelfPlanAndSendFunctions;
  replaceFeeBeneficiary: (
    input: ReplaceFeeBeneficiaryAsyncInput,
  ) => ReturnType<typeof getReplaceFeeBeneficiaryInstructionAsync> &
    SelfPlanAndSendFunctions;
  setFeePolicy: (
    input: SetFeePolicyAsyncInput,
  ) => ReturnType<typeof getSetFeePolicyInstructionAsync> &
    SelfPlanAndSendFunctions;
  setHookAllowlist: (
    input: SetHookAllowlistAsyncInput,
  ) => ReturnType<typeof getSetHookAllowlistInstructionAsync> &
    SelfPlanAndSendFunctions;
  setMigratorAllowlist: (
    input: SetMigratorAllowlistAsyncInput,
  ) => ReturnType<typeof getSetMigratorAllowlistInstructionAsync> &
    SelfPlanAndSendFunctions;
  transferAdmin: (
    input: TransferAdminAsyncInput,
  ) => ReturnType<typeof getTransferAdminInstructionAsync> &
    SelfPlanAndSendFunctions;
  updateTradingFlags: (
    input: UpdateTradingFlagsAsyncInput,
  ) => ReturnType<typeof getUpdateTradingFlagsInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type InitializerPluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function initializerProgram() {
  return <T extends InitializerPluginRequirements>(client: T) => {
    return {
      ...client,
      initializer: <InitializerPlugin>{
        accounts: {
          initConfig: addSelfFetchFunctions(client, getInitConfigCodec()),
          launch: addSelfFetchFunctions(client, getLaunchCodec()),
          launchFeeState: addSelfFetchFunctions(
            client,
            getLaunchFeeStateCodec(),
          ),
          pool: addSelfFetchFunctions(client, getPoolCodec()),
          position: addSelfFetchFunctions(client, getPositionCodec()),
          vestingConfig: addSelfFetchFunctions(client, getVestingConfigCodec()),
        },
        instructions: {
          claimFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getClaimFeesInstructionAsync(input),
            ),
          curveSwapExactIn: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCurveSwapExactInInstructionAsync(input),
            ),
          distributeBaseAllocationNoMigration: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getDistributeBaseAllocationNoMigrationInstructionAsync(input),
            ),
          fundVesting: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getFundVestingInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          harvestMigratedFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getHarvestMigratedFeesInstructionAsync(input),
            ),
          initializeConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeConfigInstructionAsync(input),
            ),
          initializeLaunch: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeLaunchInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          migrateLaunch: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getMigrateLaunchInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          migratorInit: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getMigratorInitInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          previewMigration: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getPreviewMigrationInstructionAsync(input),
            ),
          previewSwapExactIn: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getPreviewSwapExactInInstructionAsync(input),
            ),
          replaceFeeBeneficiary: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getReplaceFeeBeneficiaryInstructionAsync(input),
            ),
          setFeePolicy: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSetFeePolicyInstructionAsync(input),
            ),
          setHookAllowlist: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSetHookAllowlistInstructionAsync(input),
            ),
          setMigratorAllowlist: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSetMigratorAllowlistInstructionAsync(input),
            ),
          transferAdmin: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getTransferAdminInstructionAsync(input),
            ),
          updateTradingFlags: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getUpdateTradingFlagsInstructionAsync(input),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
